import React, { useEffect, useState, useMemo } from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import {
  getVideoLookTeachers,
  getVideoLookCourses,
  getVideoLookGroups,
  getVideoLookList
} from '../../actions/videoRecords'
import Input from '../../components/Input'
import CustomSelect from '../../components/CustomSelect'
import Button from '../../components/Button'
import Table from '../../components/Table'
import Loader from '../../components/Loader'
import Modal from './Modal'
import moment from 'moment'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { IoMdRefresh, IoMdVideocam } from 'react-icons/io'

export default function VideoLessons() {
  const dispatch = useDispatch()
  const {
    videoLookList,
    videoLookTeachers,
    videoLookCourses,
    videoLookGroups,
    videoLookLoading
  } = useSelector(state => state.video_records)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [selectedRowId, setSelectedRowId] = useState(null)
  const [sortField, setSortField] = useState('lesson_date')
  const [sortAsc, setSortAsc] = useState(true)

  const handleSort = (field) => {
    if (sortField === field) setSortAsc(v => !v)
    else { setSortField(field); setSortAsc(true) }
  }

  const sortedList = useMemo(() => {
    if (!videoLookList) return []
    return [...videoLookList].sort((a, b) => {
      const aVal = a[sortField] ?? ''
      const bVal = b[sortField] ?? ''
      if (typeof aVal === 'number' && typeof bVal === 'number')
        return sortAsc ? aVal - bVal : bVal - aVal
      return sortAsc
        ? String(aVal).localeCompare(String(bVal), 'ru')
        : String(bVal).localeCompare(String(aVal), 'ru')
    })
  }, [videoLookList, sortField, sortAsc])
  const [formData, setFormData] = useState({
    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD'),
  })

  useEffect(() => {
    dispatch(getVideoLookTeachers({
      date_from: moment().format('YYYY-MM-DD'),
      date_to: moment().format('YYYY-MM-DD'),
    }))
    dispatch(getVideoLookCourses({
      date_from: moment().format('YYYY-MM-DD'),
      date_to: moment().format('YYYY-MM-DD'),
    }))

    dispatch(getVideoLookList(formData))
  }, [])

  useEffect(() => {
    dispatch(getVideoLookTeachers({ date_from: formData.date_from, date_to: formData.date_to }))
    dispatch(getVideoLookCourses({ date_from: formData.date_from, date_to: formData.date_to }))
    dispatch(getVideoLookGroups(formData))
    // dispatch(getVideoLookList(formData))
  }, [formData.date_from, formData.date_to])
  useEffect(() => {
    formData.subject_id && dispatch(getVideoLookGroups(formData))
    // dispatch(getVideoLookList(formData))
  }, [formData.subject_id])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSelectChange = (name, value) => {
    setFormData({ ...formData, [name]: value === 0 ? '' : value })
  }

  const handleRefresh = () => {
    dispatch(getVideoLookList(formData))
  }

  const openVideoModal = (record) => () => {
    setSelectedRecord(record)
  }

  const closeModal = () => {
    setSelectedRecord(null)
  }

  const handleRowClick = (record) => () => {
    setSelectedRowId(record.id)
    setSelectedRecord(record)
  }

  const renderRow = (record) => {
    const {
      id,
      lesson_date,
      period_name,
      room_name,
      description,
      is_active,
      teacher,
      class_name,
      subject_name
    } = record

    const isSelected = selectedRowId === id

    return (
      <tr
        key={id}
        onClick={handleRowClick(record)}
        style={{
          cursor: 'pointer',
          backgroundColor: isSelected ? '#c5ddff' : ''
        }}
      >
        <td>{moment(lesson_date).format('DD.MM.YYYY')}</td>
        <td>{period_name}</td>
        <td>{room_name}</td>
        <td>{description}</td>
        <td>
          <input type="checkbox" checked={is_active} readOnly />
        </td>
        <td>{teacher}</td>
        <td>{class_name}</td>
        <td>{subject_name}</td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper}>
      <Modal
        record={selectedRecord}
        open={!!selectedRecord}
        closeModal={closeModal}
      />

      <h1>Видеоуроки</h1>

      <div className={styles.filters}>
        <div className={styles.filtersContainer}>
          <div className={styles.filtersRow}>
            <Input
              type='date'
              title='C'
              name='date_from'
              value={formData.date_from}
              onChange={handleInputChange}
            />
            <Input
              type='date'
              title='по'
              name='date_to'
              value={formData.date_to}
              onChange={handleInputChange}
            />
            <Button onClick={handleRefresh} className={styles.refreshButton}>
              <IoMdRefresh size={20} />
              Обновить
            </Button>
          </div>
          <div className={styles.filtersRow}>
            <CustomSelect
              title='Преподаватель'
              valuesName="teacher_id"
              options={videoLookTeachers && arrayForSelect(videoLookTeachers, 'teacher_name', 'teacher_id')}
              setFieldValue={handleSelectChange}
              value={formData.teacher_id}
            />
            <CustomSelect
              title='Предмет'
              valuesName="subject_id"
              options={videoLookCourses && arrayForSelect(videoLookCourses, 'course_name', 'course_id')}
              setFieldValue={handleSelectChange}
              value={formData.subject_id}
            />
            <CustomSelect
              title='Класс'
              valuesName="class_id"
              options={videoLookGroups && arrayForSelect(videoLookGroups, 'group_name', 'group_id')}
              setFieldValue={handleSelectChange}
              value={formData.class_id}
            />
          </div>
        </div>
      </div>

      {videoLookLoading ? (
        <Loader />
      ) : (
        <Table>
          <thead>
            <tr>
              <th onClick={() => handleSort('lesson_date')} style={{ cursor: 'pointer' }}>Дата съемки</th>
              <th>Урок</th>
              <th>Кабинет</th>
              <th>Описание</th>
              <th>Активна</th>
              <th onClick={() => handleSort('teacher')} style={{ cursor: 'pointer' }}>Преподаватель</th>
              <th onClick={() => handleSort('class_name')} style={{ cursor: 'pointer' }}>Класс</th>
              <th onClick={() => handleSort('subject_name')} style={{ cursor: 'pointer' }}>Предмет</th>
            </tr>
          </thead>
          <tbody>
            {sortedList.length > 0 ? (
              sortedList.map(renderRow)
            ) : (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', padding: '2rem' }}>
                  По заданным параметрам данные отсутствуют
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}

      <div className={styles.footer}>
        <Button onClick={selectedRecord ? openVideoModal(selectedRecord) : undefined} disabled={!selectedRecord}>
          <IoMdVideocam size={20} />
          Видео
        </Button>
      </div>
    </div>
  )
}

